import {Tab} from "@mui/material";
import React from "react";
import withStyles from '@mui/styles/withStyles';
import { orange, purple } from '@mui/material/colors';

const CaseTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 155,
        minHeight: 40,
        maxHeight: 10,
        marginRight: theme.spacing(1),
        fontSize: 14 ,
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        backgroundColor: props => props.warning ? orange["600"] : props.appellantwarning ? purple["600"] : '#0E2361',
        borderRadius: 30,
        color: '#FFFFFF',
        marginBottom: 10,
        opacity: 1,
        '&:hover': {
            color: props => props.warning ? orange["100"] : props.appellantwarning ? purple["100"] : '#40a9ff',
        },
        '&.Mui-selected': {
            color: '#FFFFFF',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: props => props.warning ? orange["300"] : props.appellantwarning ? purple["300"] : '#7BAFDF' ,
            borderRadius: 50,
            opacity: 1,
        },
        '&:focus': {
            color: '#FFFFFF',
        },
        '&.Mui-selected:focus': {
            color: '#FFFFFF',
        },
    },
    selected: {},
}))(({...restProps}) => <Tab disableRipple {...restProps} />);

export default CaseTab;